/**
 * Created by baladewa on 9/1/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name createPairing.controller:MissingItemsCtrl
     *
     * @description
     *
     */
    angular
        .module('createPairing')
        .controller('IllegalCrewMapCtrl', IllegalCrewMapCtrl);

    function IllegalCrewMapCtrl($uibModalInstance, modalParams) {
        var vm = this;
        vm.ctrlName = 'IllegalCrewMapCtrl';
        vm.model = {
            illegalCrewMap : convertMapToArray(modalParams.crewMap)
        };

        function convertMapToArray(crewMap){
            var mapArray = [];
            for (var crew in crewMap){
                var crewMapArray = crewMap[crew];
                for (var i=0;i<crewMapArray.length;i++){
                    var temp = crewMapArray[i];
                    temp.crewId = crew;
                    mapArray[mapArray.length] = temp;
                }
            }
            return mapArray;
        }

        vm.clickYes = function(){
            $uibModalInstance.close('YES');
        };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());
